import { render, staticRenderFns } from "./zhibojian.vue?vue&type=template&id=166c4036&scoped=true&"
import script from "./zhibojian.vue?vue&type=script&lang=js&"
export * from "./zhibojian.vue?vue&type=script&lang=js&"
import style0 from "./zhibojian.vue?vue&type=style&index=0&id=166c4036&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166c4036",
  null
  
)

export default component.exports